module.exports = __webpack_public_path__ + "static/media/12UNCTAD4.316f0e7a.jpg";